import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const BadgeFallingPrice: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 17 16"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <g id="Live area">
        <g id="Vector">
          <path
            d="M13.2112 1.41566L14.1957 2.42404C14.3842 2.61241 14.3842 2.93377 14.2062 3.13323L8.006 10.1697L10.0692 12.0978C10.3625 12.3749 10.2473 12.8846 9.87025 12.9954L3.62815 14.7019C3.21969 14.8127 2.83218 14.4692 2.8636 14.0259L3.35584 7.10026C3.38726 6.67918 3.85856 6.46864 4.16229 6.73458L6.29885 8.56296L12.5305 1.43782C12.7085 1.22728 13.0122 1.22728 13.2008 1.41566H13.2112Z"
            fill="#FF573E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.021 1.61702C12.9321 1.52816 12.7986 1.53618 12.7256 1.6225L12.7227 1.62596L6.32467 8.94131L3.99766 6.94994L3.99538 6.94797C3.85661 6.82646 3.63209 6.92241 3.61692 7.1216L3.12472 14.0466C3.10678 14.3002 3.3276 14.4972 3.56283 14.4336L9.80209 12.7279C9.97998 12.674 10.0314 12.434 9.8953 12.3048L7.6311 10.1889L14.0147 2.94428L14.0159 2.94298C14.1007 2.84792 14.093 2.7024 14.016 2.6254L14.0136 2.62305L13.1053 1.69265H13.0967L13.021 1.61702ZM13.2921 1.13859C13.0032 0.928413 12.5928 0.950587 12.337 1.25118L6.27307 8.18455L4.32797 6.52001C3.85936 6.11142 3.14276 6.43632 3.09485 7.07842L2.60253 14.0051C2.55767 14.6379 3.11166 15.128 3.69321 14.9702L9.93578 13.2636L9.94035 13.2623C10.5148 13.0934 10.693 12.3157 10.2437 11.8911L8.38095 10.1504L14.3966 3.3234C14.6668 3.01992 14.6753 2.52358 14.3769 2.22392L13.3172 1.13859H13.2921Z"
            fill="black"
          />
        </g>
      </g>
    </svg>
  );
};

export default BadgeFallingPrice;
